import { Link } from 'react-router-dom';
import { Instagram } from 'lucide-react';

const VVS_LOGO = 'https://customer-assets.emergentagent.com/job_ac09e30e-ff84-4be5-9a8e-38b36c255d06/artifacts/yqc71nna_FromNow2.jpg';

// SoundCloud icon component
const SoundCloudIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M1.175 12.225c-.051 0-.094.046-.101.1l-.233 2.154.233 2.105c.007.058.05.098.101.098.05 0 .09-.04.099-.098l.255-2.105-.255-2.154c-.009-.053-.05-.1-.099-.1m-.899.828c-.06 0-.091.037-.104.094L0 14.479l.172 1.308c.013.057.044.094.104.094.058 0 .091-.037.1-.094l.199-1.308-.199-1.332c-.009-.057-.042-.094-.1-.094m1.93-1.582c-.073 0-.121.053-.128.126l-.178 2.882.178 2.776c.007.073.055.126.128.126.072 0 .12-.053.126-.126l.203-2.776-.203-2.882c-.006-.073-.054-.126-.126-.126m.93-.312c-.087 0-.143.063-.149.148l-.153 3.194.153 3.063c.006.085.062.148.149.148.086 0 .143-.063.148-.148l.173-3.063-.173-3.194c-.005-.085-.062-.148-.148-.148m.93-.469c-.1 0-.165.074-.171.169l-.128 3.663.128 3.303c.006.096.071.17.171.17.099 0 .165-.074.169-.17l.145-3.303-.145-3.663c-.004-.095-.07-.169-.169-.169m.93-.469c-.114 0-.186.086-.191.195l-.103 4.132.103 3.423c.005.11.077.196.191.196.113 0 .186-.086.19-.196l.116-3.423-.116-4.132c-.004-.109-.077-.195-.19-.195m.93-.284c-.127 0-.204.097-.208.22l-.078 4.416.078 3.458c.004.123.081.22.208.22.126 0 .204-.097.207-.22l.088-3.458-.088-4.416c-.003-.123-.081-.22-.207-.22m1.168-.128c-.142 0-.229.107-.231.242l-.053 4.544.053 3.458c.002.135.089.242.231.242.141 0 .228-.107.23-.242l.059-3.458-.059-4.544c-.002-.135-.089-.242-.23-.242m.93-.156c-.155 0-.25.118-.251.265l-.028 4.7.028 3.423c.001.147.096.265.251.265.154 0 .249-.118.25-.265l.032-3.423-.032-4.7c-.001-.147-.096-.265-.25-.265m.931-.156c-.168 0-.269.13-.27.288l-.003 4.856.003 3.388c.001.159.102.288.27.288.167 0 .268-.129.269-.288l.003-3.388-.003-4.856c-.001-.158-.102-.288-.269-.288m1.963-.003c-.089.001-.153.027-.209.076-.058.051-.093.123-.094.207l-.022 4.879.022 3.33c.001.084.036.156.094.207.057.049.12.076.209.076.089 0 .152-.027.209-.076.057-.051.093-.123.093-.207v.003l.025-3.333-.025-4.879c0-.084-.036-.156-.093-.207-.057-.049-.12-.076-.209-.076m4.31 1.618c-.375 0-.732.065-1.065.186-.22-2.49-2.301-4.446-4.867-4.446-.594 0-1.166.111-1.693.31-.197.073-.249.148-.251.295v8.746c.002.152.121.273.27.287h7.606c1.302 0 2.36-1.058 2.36-2.36 0-1.301-1.058-2.359-2.36-2.359"/>
  </svg>
);

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      style={{
        position: 'relative',
        zIndex: 1,
        padding: '48px 20px',
        background: 'rgba(5, 10, 20, 0.8)',
      }}
    >
      {/* Gradient separator line */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        width: '100%',
        maxWidth: '1200px',
        height: '1px',
        background: 'linear-gradient(90deg, transparent 0%, rgba(240,244,248,0.1) 25%, rgba(240,244,248,0.12) 50%, rgba(240,244,248,0.1) 75%, transparent 100%)',
      }} />

      <div style={{ 
        maxWidth: '1200px', 
        margin: '0 auto', 
        display: 'flex', 
        flexDirection: 'column',
        gap: '32px',
      }}>
        {/* Top row: Brand + Socials */}
        <div style={{ 
          display: 'flex', 
          flexWrap: 'wrap', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          gap: '24px',
        }}>
          {/* Brand */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <img src={VVS_LOGO} alt="VVS" style={{ width: '32px', height: '32px', objectFit: 'cover', borderRadius: '50%', opacity: 0.8 }} />
            <div>
              <p style={{ fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: '13px', letterSpacing: '0.2em', color: '#F0F4F8', margin: 0 }}>VAGUE VISION SOUND</p>
              <p style={{ fontFamily: 'Space Grotesk, sans-serif', fontSize: '11px', color: 'var(--vvs-muted)', margin: '2px 0 0', letterSpacing: '0.1em' }}>Sound shaped in waves.</p>
            </div>
          </div>

          {/* Socials */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <a
              href="https://www.instagram.com/vaguevisionsound/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              style={{ 
                color: 'rgba(148,163,184,0.4)', 
                transition: 'all 0.3s ease',
                padding: '10px',
                minWidth: '44px',
                minHeight: '44px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              aria-label="VVS Instagram"
              onMouseEnter={e => {
                e.currentTarget.style.color = '#F0F4F8';
                e.currentTarget.style.filter = 'drop-shadow(0 0 6px rgba(100,180,255,0.4))';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.color = 'rgba(148,163,184,0.4)';
                e.currentTarget.style.filter = 'none';
              }}
            >
              <Instagram size={18} />
            </a>
            <a
              href="https://soundcloud.com/vaguevisionsound"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-soundcloud"
              style={{ 
                color: 'rgba(148,163,184,0.4)', 
                transition: 'all 0.3s ease',
                padding: '10px',
                minWidth: '44px',
                minHeight: '44px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              aria-label="VVS SoundCloud"
              onMouseEnter={e => {
                e.currentTarget.style.color = '#F0F4F8';
                e.currentTarget.style.filter = 'drop-shadow(0 0 6px rgba(100,180,255,0.4))';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.color = 'rgba(148,163,184,0.4)';
                e.currentTarget.style.filter = 'none';
              }}
            >
              <SoundCloudIcon size={18} />
            </a>
          </div>
        </div>

        {/* Middle section: Nav links + Legal */}
        <div style={{ 
          display: 'flex', 
          flexWrap: 'wrap', 
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          gap: '32px',
        }}>
          {/* Nav links */}
          <div style={{ 
            display: 'flex', 
            flexWrap: 'wrap',
            gap: '8px 24px',
          }}>
            {[
              { label: 'Vision', path: '/vision' },
              { label: 'Music', path: '/releases' },
              { label: 'Partners', path: '/partners' },
              { label: 'Contact', path: '/contact' },
            ].map(l => (
              <Link 
                key={l.path} 
                to={l.path} 
                style={{ 
                  fontFamily: 'Space Grotesk, sans-serif', 
                  fontSize: '11px', 
                  letterSpacing: '0.15em', 
                  textTransform: 'uppercase', 
                  color: 'var(--vvs-muted)', 
                  textDecoration: 'none', 
                  transition: 'color 0.3s',
                  padding: '8px 0',
                  minHeight: '44px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                onMouseEnter={e => e.currentTarget.style.color = '#F0F4F8'}
                onMouseLeave={e => e.currentTarget.style.color = 'var(--vvs-muted)'}
                data-testid={`footer-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </Link>
            ))}
          </div>

          {/* Legal section - aligned right */}
          <div style={{ 
            display: 'flex', 
            flexDirection: 'column',
            alignItems: 'flex-end',
            gap: '8px',
          }}>
            <p style={{ 
              fontFamily: 'Space Grotesk, sans-serif', 
              fontSize: '10px', 
              letterSpacing: '0.15em', 
              textTransform: 'uppercase',
              color: 'rgba(148,163,184,0.5)', 
              margin: '0',
            }}>
              Legal
            </p>
            <div style={{ 
              display: 'flex', 
              flexWrap: 'wrap', 
              justifyContent: 'flex-end',
              gap: '6px 16px',
            }}>
              {[
                { label: 'Privacy', path: '/legal/privacy' },
                { label: 'Terms', path: '/legal/terms' },
                { label: 'Refund', path: '/legal/refund' },
                { label: 'Legal Notice', path: '/legal/notice' },
                { label: 'Event T&C', path: '/legal/events' },
              ].map(l => (
                <Link 
                  key={l.path} 
                  to={l.path} 
                  style={{ 
                    fontFamily: 'Space Grotesk, sans-serif', 
                    fontSize: '11px', 
                    letterSpacing: '0.06em', 
                    color: 'rgba(148,163,184,0.55)', 
                    textDecoration: 'none', 
                    transition: 'color 0.3s',
                    padding: '4px 0',
                  }}
                  onMouseEnter={e => e.currentTarget.style.color = '#F0F4F8'}
                  onMouseLeave={e => e.currentTarget.style.color = 'rgba(148,163,184,0.55)'}
                  data-testid={`footer-legal-${l.label.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  {l.label}
                </Link>
              ))}
            </div>
          </div>
        </div>

        {/* Email */}
        <a href="mailto:contact@vaguevisionsound.com"
          data-testid="footer-email"
          style={{ 
            fontFamily: 'Space Grotesk, sans-serif', 
            fontSize: '12px', 
            letterSpacing: '0.1em', 
            color: 'var(--vvs-muted)', 
            textDecoration: 'none', 
            transition: 'color 0.3s',
            padding: '8px 0',
            marginTop: '16px',
          }}
          onMouseEnter={e => e.currentTarget.style.color = 'var(--vvs-cyan)'}
          onMouseLeave={e => e.currentTarget.style.color = 'var(--vvs-muted)'}
        >
          contact@vaguevisionsound.com
        </a>
      </div>

      {/* Bottom row */}
      <div style={{ 
        maxWidth: '1200px', 
        margin: '24px auto 0', 
        paddingTop: '24px', 
        position: 'relative',
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center',
        gap: '12px',
        textAlign: 'center',
      }}>
        {/* Gradient separator */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: '0',
          width: '100%',
          height: '1px',
          background: 'linear-gradient(90deg, transparent 0%, rgba(240,244,248,0.07) 30%, rgba(240,244,248,0.07) 70%, transparent 100%)',
        }} />
        
        <p style={{ fontFamily: 'Space Grotesk, sans-serif', fontSize: '10px', letterSpacing: '0.1em', color: 'rgba(148,163,184,0.4)', margin: 0 }}>
          © 2025 Vague Vision Sound // Sound shaped in waves.
        </p>
        
        {/* Fairflow with mauve-blue gradient */}
        <a 
          href="https://fairflow.be" 
          target="_blank" 
          rel="noopener noreferrer" 
          data-testid="footer-fairflow"
          style={{ 
            fontFamily: 'Space Grotesk, sans-serif', 
            fontSize: '10px', 
            letterSpacing: '0.15em', 
            textTransform: 'uppercase', 
            background: 'linear-gradient(135deg, rgba(138,92,246,0.7), rgba(59,130,246,0.7))',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            textDecoration: 'none', 
            transition: 'all 0.3s',
            animation: 'fairflow-footer-shimmer 3s ease-in-out infinite',
            padding: '8px',
          }}
        >
          Fairflow App
        </a>
        
        <style>
          {`
            @keyframes fairflow-footer-shimmer {
              0%, 100% {
                filter: brightness(1);
              }
              50% {
                filter: brightness(1.3);
              }
            }
          `}
        </style>
      </div>
    </footer>
  );
}
